"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRSPToken = exports.containCompTokens = exports.containSysTokens = exports.containRefTokens = exports.parseRSPCompToken = exports.parseRSPSysToken = exports.parseRSPRefToken = void 0;
var component_2023_utils_tokens_1 = require("@rentspree/component-2023.utils.tokens");
var RefTokenPrefix = 'rsp.ref';
var SysTokenPrefix = 'rsp.sys';
var CompTokenPrefix = 'rsp.comp';
var parseRSPRefToken = function (token) {
    if ((0, component_2023_utils_tokens_1.isRSPRefToken)(token))
        return component_2023_utils_tokens_1.rspRefTokens[token];
    return token;
};
exports.parseRSPRefToken = parseRSPRefToken;
var parseRSPSysToken = function (token) {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    var resolvedToken;
    if ((0, component_2023_utils_tokens_1.isRSPSysToken)(token)) {
        resolvedToken = component_2023_utils_tokens_1.rspSysTokens[token];
    }
    else {
        resolvedToken = token;
    }
    if (typeof resolvedToken === 'string' && (0, component_2023_utils_tokens_1.isRSPRefToken)(resolvedToken)) {
        return (0, exports.parseRSPRefToken)(resolvedToken);
    }
    return resolvedToken;
};
exports.parseRSPSysToken = parseRSPSysToken;
var parseRSPCompToken = function (token) {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    var resolvedToken;
    if ((0, component_2023_utils_tokens_1.isRSPCompToken)(token)) {
        resolvedToken = component_2023_utils_tokens_1.rspCompTokens[token];
    }
    else {
        resolvedToken = token;
    }
    if (typeof resolvedToken !== 'string')
        return resolvedToken;
    if ((0, component_2023_utils_tokens_1.isRSPSysToken)(resolvedToken))
        return (0, exports.parseRSPSysToken)(resolvedToken);
    if ((0, component_2023_utils_tokens_1.isRSPRefToken)(resolvedToken))
        return (0, exports.parseRSPRefToken)(resolvedToken);
    return resolvedToken;
};
exports.parseRSPCompToken = parseRSPCompToken;
var containRefTokens = function (token) { return token.includes(RefTokenPrefix); };
exports.containRefTokens = containRefTokens;
var containSysTokens = function (token) { return token.includes(SysTokenPrefix); };
exports.containSysTokens = containSysTokens;
var containCompTokens = function (token) { return token.includes(CompTokenPrefix); };
exports.containCompTokens = containCompTokens;
var parseRSPToken = function (token) {
    var parsedToken = token;
    if ((0, exports.containCompTokens)(parsedToken)) {
        parsedToken = parsedToken.replaceAll(/(rsp.comp).([a-z0-9.-]+)/g, exports.parseRSPCompToken);
    }
    if ((0, exports.containSysTokens)(parsedToken)) {
        parsedToken = parsedToken.replaceAll(/(rsp.sys).([a-z0-9.-]+)/g, exports.parseRSPSysToken);
    }
    if ((0, exports.containRefTokens)(parsedToken)) {
        parsedToken = parsedToken.replaceAll(/(rsp.ref).([a-z0-9.-]+)/g, exports.parseRSPRefToken);
    }
    return parsedToken;
};
exports.parseRSPToken = parseRSPToken;
//# sourceMappingURL=token-parsers.js.map